import { render, staticRenderFns } from "./_dashboard.vue?vue&type=template&id=c982d2a8&lang=pug"
import script from "./_dashboard.vue?vue&type=script&lang=js"
export * from "./_dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports